// @ts-nocheck
import CryptoJS from 'crypto-js';

export function decrypt(encryptedText: string): string {
  try {
    const secretKey = process.env.REACT_APP_CARD_KEY;
    if (!secretKey) {
      throw new Error('secretKey is required for decryption');
    }

    // Anahtarın doğru uzunlukta olduğundan emin olun (örneğin, 32 byte)
    const keyBytes = CryptoJS.enc.Utf8.parse(secretKey);

    // Şifreli veriyi Base64 formatından çözme
    const encryptedData = CryptoJS.enc.Base64.parse(encryptedText);

    // IV ve şifreli veriyi ayırma
    const iv = CryptoJS.lib.WordArray.create(encryptedData.words.slice(0, 4)); // İlk 16 byte IV
    const ciphertext = CryptoJS.lib.WordArray.create(encryptedData.words.slice(4)); // Geri kalan şifreli veri

    // Veriyi çözme
    const decrypted = CryptoJS.AES.decrypt({ ciphertext }, keyBytes, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Çözülen veriyi UTF-8 formatında döndürme
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    return '';
  }
}
